import { render } from "./ExitToApp.vue?vue&type=template&id=371e4e25"
import script from "./ExitToApp.vue?vue&type=script&lang=js"
export * from "./ExitToApp.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__